import React, { useState } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword, sendPasswordResetEmail } from 'firebase/auth';
import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { initializeApp } from 'firebase/app';
import NavbarComponent from './components/NavbarComponent';
import FooterComponent from './components/FooterComponent';
import AuthForm from './components/AuthForm';

// ✅ Firebase configuration (Kept inside Bootypage.jsx)
const firebaseConfig = {
  apiKey: "AIzaSyBqW03Ps5U0j5gBzFPKHugvOB8HeRgCNJc",
  authDomain: "localhost:3000",
  projectId: "fintorro-website",
  storageBucket: "fintorro-website.appspot.com",
  messagingSenderId: "323588876484",
  appId: "1:323588876484:web:b6e0655caf83e183384191",
  measurementId: "G-K8EM0MTH6M"
};

// ✅ Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);

const Bootypage = () => {
  const [isSignUp, setIsSignUp] = useState(true);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState(null);
  const [resetMode, setResetMode] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const navigate = useNavigate();

  const toggleAuthMode = () => {
    setIsSignUp(!isSignUp);
    setError(null);
    setSuccessMessage(null);
  };

  const handleAuth = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage(null);

    try {
      if (isSignUp) {
        const userCredential = await createUserWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        await addDoc(collection(db, "users"), {
          uid: user.uid,
          email: user.email,
          firstname: "",
          lastname: "",
          isActive: true,
          createdAt: serverTimestamp(),
        });

        await addDoc(collection(db, "userstreaktotal"), { userid: user.uid, totalstreakcount: 0, date: serverTimestamp() });
        await addDoc(collection(db, "usertotaltokens"), { userid: user.uid, totaltokens: 0, date: serverTimestamp() });

        setSuccessMessage('Signup Successful!');
      } else {
        const userCredential = await signInWithEmailAndPassword(auth, email, password);
        const user = userCredential.user;
        localStorage.setItem('incorrectAnswerCount', '0');
        localStorage.setItem('lastAttemptTimestamp', Date.now());

        await addDoc(collection(db, "userloginaudit"), { userId: user.uid, dateOfLogin: serverTimestamp() });

        setSuccessMessage('Login Successful!');
        navigate('/welcome');
      }
    } catch (err) {
      setError(err.message);
    }
  };

  const sendPasswordReset = async () => {
    try {
      await sendPasswordResetEmail(auth, resetEmail);
      setSuccessMessage('Password reset email sent.');
    } catch (error) {
      setError('Failed to send password reset email.');
    }
  };

  return (
    <div style={{ fontFamily: 'Nunito Sans', color: '#232830' }}>
      {/* Navbar */}
      <NavbarComponent />

      {/* Main Content */}
      <main className="container my-5">
        <Row className="justify-content-center">
          <Col md={6} style={{ 
            background: '#FFFFFF', 
            borderRadius: '16px', 
            padding: '40px', 
            boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)', 
            textAlign: 'center'
          }}>
            <h2 
              style={{ 
                fontSize: '28px', 
                fontWeight: 'bold', 
                color: '#28A745', 
                borderRadius: '12px',
                padding: '10px 15px'
              }}>
              Learn Lifelong Trading & Investing Skills
            </h2>
            
            <p 
              style={{ 
                fontSize: '20px', 
                fontWeight: '600', 
                color: '#FF7C24', 
                borderRadius: '10px', 
                padding: '8px 12px' 
              }}>
              Easy and Bite-Sized Learning
            </p>

            {/* Authentication Form Component */}
            <AuthForm
              isSignUp={isSignUp}
              setIsSignUp={setIsSignUp}
              email={email}
              setEmail={setEmail}
              password={password}
              setPassword={setPassword}
              handleAuth={handleAuth}
              toggleAuthMode={toggleAuthMode}
              resetMode={resetMode}
              setResetMode={setResetMode}
              resetEmail={resetEmail}
              setResetEmail={setResetEmail}
              sendPasswordReset={sendPasswordReset}
              error={error}
              successMessage={successMessage}
            />
          </Col>
        </Row>
      </main>

      {/* Footer */}
      <FooterComponent />
    </div>
  );
};

export default Bootypage;





// import 'bootstrap/dist/css/bootstrap.min.css';
// import { Navbar, Nav, Container, Row, Col, Form, Button } from 'react-bootstrap';
// import { FaWhatsapp, FaInstagram, FaYoutube, FaTwitter, FaTiktok } from 'react-icons/fa';
// import { getAuth, createUserWithEmailAndPassword, signInWithEmailAndPassword } from 'firebase/auth';
// import { getFirestore, collection, addDoc, serverTimestamp } from 'firebase/firestore';
// import { initializeApp } from 'firebase/app';
// import { sendPasswordResetEmail } from 'firebase/auth';
// import { confirmPasswordReset } from "firebase/auth";
// import { useNavigate } from 'react-router-dom'; // Import useNavigate hook

// // Firebase configuration
// const firebaseConfig = {
//   apiKey: "AIzaSyBqW03Ps5U0j5gBzFPKHugvOB8HeRgCNJc",
//   authDomain: "localhost:3000",
//   projectId: "fintorro-website",
//   storageBucket: "fintorro-website.appspot.com",
//   messagingSenderId: "323588876484",
//   appId: "1:323588876484:web:b6e0655caf83e183384191",
//   measurementId: "G-K8EM0MTH6M"
// };

// // Initialize Firebase
// const app = initializeApp(firebaseConfig);
// const auth = getAuth(app);
// const db = getFirestore(app);

// function App() {
//   const [isSignUp, setIsSignUp] = useState(true);
//   const [email, setEmail] = useState('');
//   const [password, setPassword] = useState('');
//   const [error, setError] = useState(null);
//   const [successMessage, setSuccessMessage] = useState(null);
//   const [resetMode, setResetMode] = useState(false); // Tracks the password reset flow
//   const [resetEmail, setResetEmail] = useState(''); // Email for password reset
//   const [verificationCode, setVerificationCode] = useState('');
//   const [generatedCode, setGeneratedCode] = useState('');
//   const [newPassword, setNewPassword] = useState('');
//   const [confirmPassword, setConfirmPassword] = useState('');
//   const navigate = useNavigate();
  

//   const toggleAuthMode = () => {
//     setIsSignUp(!isSignUp);
//     setError(null);
//     setSuccessMessage(null);
//   };


//   const handleAuth = async (e) => {
//     e.preventDefault();
//     setError(null);
//     setSuccessMessage(null);
//     try {
//       if (isSignUp) {
//         const userCredential = await createUserWithEmailAndPassword(auth, email, password);
//         const user = userCredential.user;
//         await addDoc(collection(db, "users"), {
//           uid: user.uid,
//           email: user.email,
//           firstname: "",
//           lastname: "",
//           isactive: "",
//           date: serverTimestamp(),
//         });
//          // Initialize Streaks and Tokens
//       await addDoc(collection(db, "userstreaktotal"), {
//         userid: user.uid,
//         totalstreakcount: 0,
//         date: serverTimestamp(),
//       });

//       await addDoc(collection(db, "usertotaltokens"), {
//         userid: user.uid,
//         totaltokens: 0,
//         date: serverTimestamp(),
//       });

//       console.log("New user sign-up complete with initial Tokens and Streak allocation!");
//         setSuccessMessage('Signup Successful');
//       }
//       else {
//         const userCredential = await signInWithEmailAndPassword(auth, email, password);
//         const user = userCredential.user;
//   // ✅ Reset Incorrect Answer Count for New User
// localStorage.setItem('incorrectAnswerCount', '0');
// localStorage.setItem('lastAttemptTimestamp', Date.now());

// console.log("✅ Incorrect Answer Count Reset for New User");

//         await addDoc(collection(db, "userloginaudit"), {
//           userId: user.uid,
//           dateOfLogin: serverTimestamp(),
//         });
  
//         setSuccessMessage('Login Successful');
//         navigate('/welcome');
//       }  
//   }
  
//   catch (err) {
//       console.error('Error Code:', err.code); // Log the error code for debugging
//       if (err.code === 'auth/wrong-password') {
//         setError('Invalid password. Please try again or click "Forget password?"');
//       } else if (err.code === 'auth/invalid-email') {
//         setError('Invalid email address format. Please try again.');
//       } else if (err.code === 'auth/user-not-found') {
//         setError('No account found with this email. Please check or sign up.');
//       } else {
//         setError(err.code);
//       }
//     }
//   };
  
//     // Function to send a verification code
//     const sendVerificationCode = async () => {
//       if (!resetEmail) {
//         setError('Please enter your email.');
//         return;
//       }
    
//       try {
//         // Firebase's built-in method to send the password reset email
//         await sendPasswordResetEmail(auth, resetEmail);
    
//         setSuccessMessage('A password reset email has been sent to your email address.');
//         setTimeout(() => {
//           setSuccessMessage(null);
//           setResetMode('verifyCode'); // Transition to code verification form
//         }, 3000);
//       } catch (error) {
//         console.error('Error sending password reset email:', error);
//         setError('Failed to send the password reset email. Please try again.');
//       }
//     };
    
//     const verifyCode = () => {
//       if (verificationCode === generatedCode) {
//         setResetMode('resetPassword'); // Move to password reset form
//         setError(null);
//         setSuccessMessage('Code verified. Please reset your password.');
//       } else {
//         setError('Invalid verification code. Please try again.');
//       }
//     };
    
//     const resetUserPassword = async () => {
//       if (newPassword !== confirmPassword) {
//         setError('Passwords do not match.');
//         return;
//       }
    
//       try {
//         // Assume the verification code is stored in generatedCode (from email)
//         await confirmPasswordReset(auth, generatedCode, newPassword);
    
//         setSuccessMessage('Password reset successful! You can now log in with your new password.');
//         setResetMode(false); // Redirect to login
//         setNewPassword('');
//         setConfirmPassword('');
//       } catch (error) {
//         console.error('Error resetting password:', error);
//         setError('Failed to reset the password. Please try again.');
//       }
//     };
    

 
// const sendPasswordReset = async () => {
//   try {
//     await sendPasswordResetEmail(auth, resetEmail);
//     setSuccessMessage('Password reset email has been sent.');
//   } catch (error) {
//     console.error('Error sending password reset email:', error);
//     setError('Failed to send password reset email. Please try again.');
//   }
// };
// useEffect(() => {
//   const queryParams = new URLSearchParams(window.location.search);
//   const code = queryParams.get('oobCode'); // Extract the 'oobCode' parameter
//   if (code) {
//     setGeneratedCode(code); // Store the code in state
//     setResetMode('resetPassword'); // Automatically move to the reset password form
//   }
// },[]);

// const Bootypage = () => {
//   const navigate = useNavigate(); // Initialize navigate function
//   // You can add your authentication logic here if needed
//     navigate('/welcome'); // This will navigate to WelcomePage
//   }
  

//   return (
//     <div style={{ fontFamily: 'Nunito Sans', color: '#232830' }}>
//       {/* Header */}
//       <Navbar style={{ backgroundColor: '#FF7C24' }} expand="lg">
//         <Container>
//           <Navbar.Brand href="#" style={{ color: '#FFFFFF', fontWeight: 'bold', fontSize: '24px' }}>Fintorro</Navbar.Brand>
//           <Navbar.Toggle aria-controls="basic-navbar-nav" />
//           <Navbar.Collapse id="basic-navbar-nav">
//             <Nav className="ms-auto">
//               <Nav.Link href="https://www.fintorro.com/learn" style={{ color: '#FFFFFF', fontSize: '16px' }}>Learn</Nav.Link>
//               <Nav.Link href="https://www.fintorro.com/magazine" style={{ color: '#FFFFFF', fontSize: '16px' }}>Magazine</Nav.Link>
//               <Nav.Link href="https://www.fintorro.com/financialfreedom" style={{ color: '#FFFFFF', fontSize: '16px' }}>Financial Freedom</Nav.Link>
//               <Nav.Link href="https://www.fintorro.com/challenges" style={{ color: '#FFFFFF', fontSize: '16px' }}>Challenges</Nav.Link>
//             </Nav>
//           </Navbar.Collapse>
//         </Container>
//       </Navbar>

//       {/* Body */}
//       <main className="container my-5">
//         <Row>
//           <Col md={8}>
//             <h2 style={{ fontSize: '24px', fontWeight: 'bold', color: '#FF7C24' }}>Welcome to Fintorro</h2>
//             <p style={{ fontSize: '16px', color: '#232830' }}>
//               Your journey to financial freedom starts here. Explore our resources and challenges to learn more about managing your finances effectively.
//             </p>
//             <Form className="mt-4">
//        {resetMode === false && (
//     <>
//       {/* Login/Signup Form */}
//       <Form.Group controlId="formEmail" className="mb-3">
//         <Form.Label style={{ fontSize: '16px', color: '#232830' }}>Email address</Form.Label>
//         <Form.Control
//           type="email"
//           placeholder="Enter your email"
//           value={email}
//           onChange={(e) => setEmail(e.target.value)}
//         />
//       </Form.Group>
//       <Form.Group controlId="formPassword" className="mb-3">
//         <Form.Label style={{ fontSize: '16px', color: '#232830' }}>Password</Form.Label>
//         <Form.Control
//           type="password"
//           placeholder="Enter your password"
//           value={password}
//           onChange={(e) => setPassword(e.target.value)}
//         />
//       </Form.Group>

//       <div className="mt-2">
//         <a href="#" onClick={() => setResetMode('emailInput')} style={{ color: '#FF7C24', fontSize: '14px' }}>
//           Forget Password?
//         </a>
//       </div>
//       {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//       {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}
//       <Button onClick={handleAuth} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>
//         {isSignUp ? 'Sign Up' : 'Login'}
//       </Button>
//       <div className="mt-3">
//         <a href="#" onClick={toggleAuthMode} style={{ color: '#FF7C24', fontSize: '14px' }}>
//           {isSignUp ? 'Already have an account? Sign in' : "Don't have an account? Sign up"}
//         </a>
//       </div>
//     </>
//   )}

//   {resetMode === 'emailInput' && (
//     <>
//       {/* Password Reset Email Form */}
//       <Form.Group controlId="resetEmail" className="mb-3">
//         <Form.Label>Enter your email to reset password</Form.Label>
//         <Form.Control
//           type="email"
//           placeholder="Enter your email"
//           value={resetEmail}
//           onChange={(e) => setResetEmail(e.target.value)}
//         />
//       </Form.Group>
//       {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//       {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}
//       <Button onClick={sendVerificationCode} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>
//         Send Code
//       </Button>
//     </>
//   )}

//   {resetMode === 'verifyCode' && (
//     <>
//       {/* Verification Code Form */}
//       <Form.Group controlId="verificationCode" className="mb-3">
//         <Form.Label>Enter the verification code sent to your email</Form.Label>
//         <Form.Control
//           type="text"
//           placeholder="Enter verification code"
//           value={verificationCode}
//           onChange={(e) => setVerificationCode(e.target.value)}
//         />
//       </Form.Group>
//       {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//       {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}
//       <Button onClick={verifyCode} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>
//         Verify Code
//       </Button>
//     </>
//   )}

//   {resetMode === 'resetPassword' && (
//     <>
//       {/* New Password Form */}
//       <Form.Group controlId="newPassword" className="mb-3">
//         <Form.Label>New Password</Form.Label>
//         <Form.Control
//           type="password"
//           placeholder="Enter new password"
//           value={newPassword}
//           onChange={(e) => setNewPassword(e.target.value)}
//         />
//       </Form.Group>
//       <Form.Group controlId="confirmPassword" className="mb-3">
//         <Form.Label>Confirm New Password</Form.Label>
//         <Form.Control
//           type="password"
//           placeholder="Re-enter new password"
//           value={confirmPassword}
//           onChange={(e) => setConfirmPassword(e.target.value)}
//         />
//       </Form.Group>
//       {error && <p style={{ fontSize: '14px', color: '#FF7C24' }}>{error}</p>}
//       {successMessage && <p style={{ fontSize: '14px', color: '#28a745' }}>{successMessage}</p>}
//       <Button onClick={resetUserPassword} style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>
//         Create Password
//       </Button>
//     </>
//   )}
// </Form>

//           </Col>
//           <Col md={4}>
//             <div className="card" style={{ borderColor: '#FF7C24' }}>
//               <div className="card-body">
//                 <h5 className="card-title" style={{ fontSize: '18px', color: '#232830' }}>Join Our Challenges</h5>
//                 <p className="card-text" style={{ fontSize: '14px', color: '#232830' }}>
//                   Participate in our financial challenges to take control of your future.
//                 </p>
//                 <a href="https://www.fintorro.com/challenges" className="btn btn-primary" style={{ backgroundColor: '#FF7C24', borderColor: '#FF7C24' }}>Get Started</a>
//               </div>
//             </div>
//           </Col>
//         </Row>
//       </main>

//       {/* Footer */}
//       <footer className="bg-dark text-white py-5">
//         <Container>
//           <Row>
//             <Col md={6}>
//               <h4 style={{ color: '#FF7C24', fontWeight: 'bold', fontSize: '24px' }}>Fintorro</h4>
//               <p style={{ fontSize: '14px' }}>Learn While Looking for opportunities!</p>
//               <div className="d-flex mt-3">
//                 <a href="https://api.whatsapp.com/message/4RKX5CK6X7AZG1?autoload=1&app_absent=0" className="me-3" aria-label="WhatsApp">
//                   <FaWhatsapp size={24} color="#25D366" />
//                 </a>
//                 <a href="https://www.instagram.com/fintorro_/" className="me-3" aria-label="Instagram">
//                   <FaInstagram size={24} color="#C13584" />
//                 </a>
//                 <a href="https://www.youtube.com/channel/UCpyXK7z3r5QIxkAECKaVsHQ" className="me-3" aria-label="Youtube">
//                   <FaYoutube size={24} color="red" />
//                 </a>
//                 <a href="https://x.com/i/flow/login?redirect_after_login=%2Ffintorro_" className="me-3" aria-label="Twitter">
//                   <FaTwitter size={24} color="#1DA1F2" />
//                 </a>
//                 <a href="https://www.tiktok.com/@fintorro" aria-label="TikTok">
//                   <FaTiktok size={24} color="black" />
//                 </a>
//               </div>
//               <div className="mt-4 d-flex flex-column">
//                 <a href="https://apps.apple.com/us/app/trading-charts-course-fintorro/id6444193731" className="mb-2">
//                   <img src="PictureBox/applestorelogo.jpg" alt="App Store" className="img-fluid" style={{ width: '150px', height: '50px' }} />
//                 </a>
//                 <a href="https://www.fintorro.com/android-signup/">
//                   <img src="PictureBox/googleplaylogo.jpg" alt="Google Play" className="img-fluid" style={{ width: '150px', height: '50px' }} />
//                 </a>
//               </div>
//             </Col>
//             <Col md={6}>
//               <a href="https://www.fintorro.com/mobile/" className="text-white d-block mb-2">
//                 Products (Mobile Apps, Blogs)
//               </a>
//               <a href="https://www.fintorro.com/privacy-policy/" className="text-white d-block">
//                 Company (Terms, Privacy Policy, Cookies Policy)
//               </a>
//             </Col>
//           </Row>
//           <Row className="text-center mt-4">
//             <Col>
//               <p>&copy; 2024 Designed & Built by FinTorro Team.</p>
//             </Col>
//           </Row>
//         </Container>
//       </footer>
//     </div>
//   );
// }

// export default App;